// Formats response time in hours to the most appropriate time unit with decimal precision
export function formatSmartResponseTime(hours) {
  if (hours === 0 || hours == null || isNaN(hours)) {
    return '0 hours';
  }

  // Convert to absolute value for calculations
  const absHours = Math.abs(hours);

  // Years (>= 365 days = 8760 hours)
  if (absHours >= 8760) {
    const years = absHours / 8760;
    return `${years.toFixed(1)} year${years >= 2 ? 's' : ''}`;
  }

  // Months (>= 30 days = 720 hours, but less than a year)
  if (absHours >= 720) {
    const months = absHours / 730; // Using 730 hours per month (30.4 days average)
    return `${months.toFixed(1)} month${months >= 2 ? 's' : ''}`;
  }

  // Weeks (>= 7 days = 168 hours, but less than a month)
  if (absHours >= 168) {
    const weeks = absHours / 168;
    return `${weeks.toFixed(1)} week${weeks >= 2 ? 's' : ''}`;
  }

  // Days (>= 24 hours, but less than a week)
  if (absHours >= 24) {
    const days = absHours / 24;
    return `${days.toFixed(1)} day${days >= 2 ? 's' : ''}`;
  }

  // Hours (less than 24 hours)
  return `${absHours.toFixed(1)} hour${absHours >= 2 ? 's' : ''}`;
} 